import { webClient } from "@shared/apis"
import { Pagination } from "@shared/types"

export default {
  get: (schedule: number | null = null, page = 1, size = 10000) =>
    webClient.get<Pagination<BanWord>>(`/ban_words`, {
      params: { schedule, page, size },
    }),
}

type BanWord = {
  word: string
}
